"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[480],{

/***/ 32558:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "e": function() { return /* binding */ LoginBanner; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var shared_model__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51480);
/* harmony import */ var theme_ui__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(98847);
/* harmony import */ var _neo_ds_components_react_button__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(42781);
/* harmony import */ var _context_TranslationContext__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(51126);
/* harmony import */ var _utils_url_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(35905);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(85893);








var loginBannerStyle = {
  loginBannerContainer: {
    flexWrap: ['wrap', 'nowrap', 'nowrap']
  },
  loginBannerBox: {
    flexDirection: ['column', 'row', 'row'],
    alignItems: 'center',
    minWidth: '100%',
    justifyContent: 'flex-start'
  },
  logoStyle: {
    width: '100px',
    minWidth: '78px',
    minHeight: '52px'
  },
  textStyle: {
    marginBottom: ['32px', 0, 0],
    marginRight: [0, '24px'],
    width: '100%'
  },
  loginLinkStyle: {
    width: ['100%', '276px', '276px'],
    justifySelf: 'flex-end',
    textDecoration: 'none'
  }
};
var LoginBanner = function LoginBanner(_ref) {
  var loginUrl = _ref.loginUrl,
      infotext = _ref.infotext,
      brand = _ref.brand;

  var _useTranslation = (0,_context_TranslationContext__WEBPACK_IMPORTED_MODULE_3__/* .useTranslation */ .$G)(),
      t = _useTranslation.t;

  var logoPath = (0,_utils_url_utils__WEBPACK_IMPORTED_MODULE_4__/* .getLogoPath */ .hX)(brand);
  var isBrandBmw = brand === shared_model__WEBPACK_IMPORTED_MODULE_1__.Brand.bmw;
  var cssBrand = brand === shared_model__WEBPACK_IMPORTED_MODULE_1__.Brand.toyota ? 'BMW' : brand.toUpperCase();
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(theme_ui__WEBPACK_IMPORTED_MODULE_6__/* .Flex */ .kC, {
    bg: "db10",
    p: 5,
    sx: loginBannerStyle.loginBannerContainer,
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(theme_ui__WEBPACK_IMPORTED_MODULE_6__/* .Flex */ .kC, {
      "data-testid": "login-box",
      sx: loginBannerStyle.loginBannerBox,
      children: [isBrandBmw && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(theme_ui__WEBPACK_IMPORTED_MODULE_6__/* .Flex */ .kC, {
        sx: loginBannerStyle.logoStyle,
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(theme_ui__WEBPACK_IMPORTED_MODULE_6__/* .Image */ .Ee, {
          src: logoPath,
          alt: ""
        })
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(theme_ui__WEBPACK_IMPORTED_MODULE_6__/* .Text */ .xv, {
        ml: isBrandBmw ? 4 : 0,
        sx: loginBannerStyle.textStyle,
        variant: brand === shared_model__WEBPACK_IMPORTED_MODULE_1__.Brand.mini ? 'body3' : 'body2',
        children: infotext
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(theme_ui__WEBPACK_IMPORTED_MODULE_6__/* .Box */ .xu, {
        className: cssBrand,
        sx: loginBannerStyle.loginLinkStyle,
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_neo_ds_components_react_button__WEBPACK_IMPORTED_MODULE_2__/* .NeoButton */ .Q, {
          "data-testid": "login-link",
          brand: cssBrand,
          variant: "tertiary",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("a", {
            href: loginUrl,
            children: t('LOGIN_BTN_LOGIN', 'SID_CD_FP')
          })
        })
      })]
    })
  });
};

/***/ }),

/***/ 81364:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ useTracking; }
/* harmony export */ });
/* harmony import */ var _var_jenkins_home_workspace_wepf_mybmwweb_appointments_main_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _var_jenkins_home_workspace_wepf_mybmwweb_appointments_main_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(16835);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var shared_libraries_frontend_shared_src_context_TrackingContext__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(36014);
/* harmony import */ var shared_libraries_frontend_shared_src_hooks_useLocalStorage__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9098);
/* harmony import */ var shared_libraries_frontend_shared_src_models_Tracking__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(84702);
/* harmony import */ var shared_libraries_frontend_shared_src_utils_checkout_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(15127);
/* harmony import */ var shared_model__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(51480);
/* harmony import */ var _contexts_AppContext__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(6724);
/* harmony import */ var _contexts_SelectedServicesContext__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(95238);
/* harmony import */ var _models_localstorage__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(42136);
/* harmony import */ var _utils_timeslot_utils__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(72213);
/* harmony import */ var _utils_tracking_utils__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(68487);



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_var_jenkins_home_workspace_wepf_mybmwweb_appointments_main_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }












var useTracking = function useTracking(_ref) {
  var _marketConfiguration$, _receivedTimeslots$ti;

  var page = _ref.page,
      marketConfiguration = _ref.marketConfiguration,
      _ref$indexPage = _ref.indexPage,
      indexPage = _ref$indexPage === void 0 ? null : _ref$indexPage,
      _ref$timeslotPage = _ref.timeslotPage,
      timeslotPage = _ref$timeslotPage === void 0 ? null : _ref$timeslotPage,
      _ref$checkoutPage = _ref.checkoutPage,
      checkoutPage = _ref$checkoutPage === void 0 ? null : _ref$checkoutPage,
      _ref$confirmationPage = _ref.confirmationPage,
      confirmationPage = _ref$confirmationPage === void 0 ? null : _ref$confirmationPage,
      _ref$customer = _ref.customer,
      customer = _ref$customer === void 0 ? null : _ref$customer,
      stage = _ref.stage;

  var _useSelectedServices = (0,_contexts_SelectedServicesContext__WEBPACK_IMPORTED_MODULE_8__/* .useSelectedServices */ .b)(),
      selectedServices = _useSelectedServices.selectedServices;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false),
      isPageViewFired = _useState[0],
      setIsPageViewFired = _useState[1];

  var _useLocalStorage = (0,shared_libraries_frontend_shared_src_hooks_useLocalStorage__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_models_localstorage__WEBPACK_IMPORTED_MODULE_9__/* .LocalStorageKeys.VEHICLE */ .d.VEHICLE, null),
      _useLocalStorage2 = (0,_var_jenkins_home_workspace_wepf_mybmwweb_appointments_main_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(_useLocalStorage, 1),
      vehicle = _useLocalStorage2[0];

  var _useLocalStorage3 = (0,shared_libraries_frontend_shared_src_hooks_useLocalStorage__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_models_localstorage__WEBPACK_IMPORTED_MODULE_9__/* .LocalStorageKeys.SELECTED_DEALER */ .d.SELECTED_DEALER, null),
      _useLocalStorage4 = (0,_var_jenkins_home_workspace_wepf_mybmwweb_appointments_main_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(_useLocalStorage3, 1),
      dealer = _useLocalStorage4[0];

  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({
    dealerError: false,
    bookingEngineError: false,
    servicesError: false,
    servicesLoaded: false,
    servicesSelected: false,
    timeslotLoadError: false,
    dateTimeError: false,
    dateSelected: false,
    selectedTimeslot: false,
    submitAppointmentError: false,
    isSubmittingAppointment: false,
    confirmation: false,
    checkoutSuccess: false,
    hasAcceptedDataRelay: false,
    isAddressSaved: false,
    isPersonalDataSaved: false
  }),
      firedEvents = _useState2[0],
      setFiredEvents = _useState2[1];

  var _useTrackingContext = (0,shared_libraries_frontend_shared_src_context_TrackingContext__WEBPACK_IMPORTED_MODULE_2__/* .useTrackingContext */ .EF)(),
      trackEvent = _useTrackingContext.trackEvent,
      trackPageLoadEvent = _useTrackingContext.trackPageLoadEvent;

  var _useAppContext = (0,_contexts_AppContext__WEBPACK_IMPORTED_MODULE_7__/* .useAppContext */ .bp)(),
      isEpaasLoaded = _useAppContext.isEpaasLoaded;

  var locale = marketConfiguration === null || marketConfiguration === void 0 ? void 0 : (_marketConfiguration$ = marketConfiguration.localizedConfig) === null || _marketConfiguration$ === void 0 ? void 0 : _marketConfiguration$.locale;
  var brand = marketConfiguration === null || marketConfiguration === void 0 ? void 0 : marketConfiguration.brand;
  var optinVersion = marketConfiguration === null || marketConfiguration === void 0 ? void 0 : marketConfiguration.optinVersion;
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    if (isEpaasLoaded && !isPageViewFired) {
      switch (page) {
        case 'index':
          {
            var dynamicTrackingData = (0,_utils_tracking_utils__WEBPACK_IMPORTED_MODULE_10__/* .getDynamicTrackingData */ .Hp)({
              pageVariant: 'real page',
              pageSubCategory1: 'form start intention',
              pageID: 'sales > oneshop > form > SRP entry',
              pageName: 'sales > oneshop > SRP entry',
              locale: locale,
              brand: brand,
              dealer: dealer,
              customer: customer,
              vehicle: vehicle,
              services: selectedServices,
              stage: stage
            });
            setIsPageViewFired(true);
            trackPageLoadEvent({
              trackingData: dynamicTrackingData
            });
            break;
          }

        case 'timeslot':
          {
            setIsPageViewFired(true);

            if (!selectedDate && !selectedTimeslot) {
              var _dynamicTrackingData = (0,_utils_tracking_utils__WEBPACK_IMPORTED_MODULE_10__/* .getDynamicTrackingData */ .Hp)({
                pageVariant: 'virtual page',
                pageSubCategory1: "step ".concat(2, "/7"),
                pageID: 'SRP date: entry = form step 2',
                pageName: 'sales > oneshop > SRP date: entry',
                locale: locale,
                brand: brand,
                dealer: dealer,
                customer: customer,
                vehicle: vehicle,
                services: selectedServices,
                stage: stage
              });

              trackPageLoadEvent({
                trackingData: _dynamicTrackingData
              });
              trackEvent({
                dynamicTrackingData: _dynamicTrackingData,
                eventEffect: 'sales > form step 2',
                subCategory: 'oneshop service repair package form',
                subCategory2: 'handraiser',
                eventCause: 'default',
                eventAction: shared_libraries_frontend_shared_src_models_Tracking__WEBPACK_IMPORTED_MODULE_4__/* .EventAction.INTERNAL_CLICK */ .AO.INTERNAL_CLICK,
                eventName: shared_libraries_frontend_shared_src_models_Tracking__WEBPACK_IMPORTED_MODULE_4__/* .EventName.FORM */ .B_.FORM,
                eventPoints: '200',
                eventPrimaryCategory: 'custom central form',
                eventType: shared_libraries_frontend_shared_src_models_Tracking__WEBPACK_IMPORTED_MODULE_4__/* .TrackingEventType.RFS */ .Js.RFS
              });
            }

            break;
          }

        default:
          break;
      }
    }
  }, [isEpaasLoaded, page, indexPage === null || indexPage === void 0 ? void 0 : indexPage.bookingEngine]);
  /* --------------- SRP Home page ------------------ */

  var _ref2 = indexPage || {},
      getServicesError = _ref2.getServicesError,
      getDealerError = _ref2.getDealerError,
      getBookingEngineError = _ref2.getBookingEngineError,
      servicesResponse = _ref2.servicesResponse,
      bookingEngine = _ref2.bookingEngine;

  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    if (vehicle && bookingEngine) {
      trackEvent({
        dynamicTrackingData: (0,_utils_tracking_utils__WEBPACK_IMPORTED_MODULE_10__/* .getDynamicTrackingData */ .Hp)({
          pageVariant: 'real page',
          pageSubCategory1: 'form start intention',
          pageID: 'sales > oneshop > form > SRP entry',
          pageName: 'sales > oneshop > SRP entry',
          locale: locale,
          brand: brand,
          dealer: dealer,
          customer: customer,
          vehicle: vehicle,
          services: selectedServices,
          stage: stage
        }),
        subCategory: 'oneshop service repair package form',
        subCategory2: 'handraiser',
        eventCause: 'default',
        eventEffect: 'sales > form start intention',
        eventAction: shared_libraries_frontend_shared_src_models_Tracking__WEBPACK_IMPORTED_MODULE_4__/* .EventAction.INTERNAL_CLICK */ .AO.INTERNAL_CLICK,
        eventName: shared_libraries_frontend_shared_src_models_Tracking__WEBPACK_IMPORTED_MODULE_4__/* .EventName.FORM */ .B_.FORM,
        eventPoints: '200',
        eventPrimaryCategory: 'custom central form',
        eventType: shared_libraries_frontend_shared_src_models_Tracking__WEBPACK_IMPORTED_MODULE_4__/* .TrackingEventType.RFS */ .Js.RFS
      });
    }
  }, [bookingEngine]);
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    if (page === 'index') {
      var _servicesResponse$ser;

      if (!getServicesError && servicesResponse && servicesResponse !== null && servicesResponse !== void 0 && (_servicesResponse$ser = servicesResponse.services) !== null && _servicesResponse$ser !== void 0 && _servicesResponse$ser.length) {
        var dynamicTrackingData = (0,_utils_tracking_utils__WEBPACK_IMPORTED_MODULE_10__/* .getDynamicTrackingData */ .Hp)({
          pageVariant: 'virtual page',
          pageSubCategory1: "step ".concat(1, "/7"),
          pageID: 'sales > oneshop > form > SRP entry: service selection',
          pageName: 'sales > oneshop > SRP entry: service selection',
          locale: locale,
          brand: brand,
          dealer: dealer,
          customer: customer,
          vehicle: vehicle,
          services: selectedServices,
          stage: stage
        });
        trackPageLoadEvent({
          trackingData: dynamicTrackingData
        });

        if (!firedEvents.servicesLoaded) {
          setFiredEvents(_objectSpread(_objectSpread({}, firedEvents), {}, {
            servicesLoaded: true
          }));
          trackEvent({
            dynamicTrackingData: dynamicTrackingData,
            subCategory: 'oneshop service repair package form',
            subCategory2: 'handraiser',
            eventCause: 'default',
            eventEffect: 'sales > form started',
            eventAction: shared_libraries_frontend_shared_src_models_Tracking__WEBPACK_IMPORTED_MODULE_4__/* .EventAction.FIRST_PAGE_LOAD */ .AO.FIRST_PAGE_LOAD,
            eventName: shared_libraries_frontend_shared_src_models_Tracking__WEBPACK_IMPORTED_MODULE_4__/* .EventName.FORM */ .B_.FORM,
            eventPoints: '200',
            eventPrimaryCategory: 'custom central form',
            eventType: shared_libraries_frontend_shared_src_models_Tracking__WEBPACK_IMPORTED_MODULE_4__/* .TrackingEventType.RFS */ .Js.RFS
          });
        }
      }
    }
  }, [servicesResponse]);
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    if (selectedServices !== null && selectedServices !== void 0 && selectedServices.length && !firedEvents.servicesSelected && page === 'index') {
      var dynamicTrackingData = (0,_utils_tracking_utils__WEBPACK_IMPORTED_MODULE_10__/* .getDynamicTrackingData */ .Hp)({
        pageVariant: 'virtual page',
        pageSubCategory1: "step ".concat(1, "/7"),
        pageID: 'sales > oneshop > form > SRP entry: service selection',
        pageName: 'sales > oneshop > SRP entry: service selection',
        locale: locale,
        brand: brand,
        dealer: dealer,
        customer: customer,
        vehicle: vehicle,
        services: selectedServices,
        stage: stage
      });
      setFiredEvents(_objectSpread(_objectSpread({}, firedEvents), {}, {
        servicesSelected: true
      }));
      trackEvent({
        dynamicTrackingData: dynamicTrackingData,
        subCategory: 'oneshop service repair package form',
        subCategory2: 'handraiser',
        eventCause: 'default',
        eventEffect: 'sales > first form interaction',
        eventAction: shared_libraries_frontend_shared_src_models_Tracking__WEBPACK_IMPORTED_MODULE_4__/* .EventAction.CHECKBOX */ .AO.CHECKBOX,
        eventName: shared_libraries_frontend_shared_src_models_Tracking__WEBPACK_IMPORTED_MODULE_4__/* .EventName.FORM */ .B_.FORM,
        eventPoints: '200',
        eventPrimaryCategory: 'custom central form',
        eventType: shared_libraries_frontend_shared_src_models_Tracking__WEBPACK_IMPORTED_MODULE_4__/* .TrackingEventType.RFS */ .Js.RFS
      });
    }
  }, [selectedServices === null || selectedServices === void 0 ? void 0 : selectedServices.length]);
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    var dynamicTrackingData = (0,_utils_tracking_utils__WEBPACK_IMPORTED_MODULE_10__/* .getDynamicTrackingData */ .Hp)({
      pageVariant: 'real page',
      pageSubCategory1: 'form start intention',
      pageID: 'sales > oneshop > form > SRP entry',
      pageName: 'sales > oneshop > SRP entry',
      locale: locale,
      brand: brand,
      dealer: dealer,
      customer: customer,
      vehicle: vehicle,
      services: selectedServices,
      stage: stage
    });

    if (getDealerError && !firedEvents.dealerError) {
      setFiredEvents(_objectSpread(_objectSpread({}, firedEvents), {}, {
        dealerError: true
      }));
      trackEvent({
        dynamicTrackingData: dynamicTrackingData,
        eventPrimaryCategory: 'custom central form',
        eventEffect: 'call to dealer endpoint failed',
        eventCause: JSON.stringify(getDealerError === null || getDealerError === void 0 ? void 0 : getDealerError.message),
        eventAction: shared_libraries_frontend_shared_src_models_Tracking__WEBPACK_IMPORTED_MODULE_4__/* .EventAction.LOAD_DEALER_FAILED */ .AO.LOAD_DEALER_FAILED,
        eventName: shared_libraries_frontend_shared_src_models_Tracking__WEBPACK_IMPORTED_MODULE_4__/* .EventName.ERROR */ .B_.ERROR,
        eventPoints: '200',
        eventType: shared_libraries_frontend_shared_src_models_Tracking__WEBPACK_IMPORTED_MODULE_4__/* .TrackingErrorType.BACKEND_FIRST_PARTY */ .k9.BACKEND_FIRST_PARTY
      });
    }

    if (getBookingEngineError && !firedEvents.bookingEngineError) {
      setFiredEvents(_objectSpread(_objectSpread({}, firedEvents), {}, {
        bookingEngineError: true
      }));
      trackEvent({
        dynamicTrackingData: dynamicTrackingData,
        eventPrimaryCategory: 'custom central form',
        eventEffect: 'call to booking engine endpoint failed',
        eventCause: JSON.stringify(getBookingEngineError === null || getBookingEngineError === void 0 ? void 0 : getBookingEngineError.message),
        eventAction: shared_libraries_frontend_shared_src_models_Tracking__WEBPACK_IMPORTED_MODULE_4__/* .EventAction.LOAD_BOOKING_ENGINE_LOAD */ .AO.LOAD_BOOKING_ENGINE_LOAD,
        eventName: shared_libraries_frontend_shared_src_models_Tracking__WEBPACK_IMPORTED_MODULE_4__/* .EventName.ERROR */ .B_.ERROR,
        eventPoints: '200',
        eventType: shared_libraries_frontend_shared_src_models_Tracking__WEBPACK_IMPORTED_MODULE_4__/* .TrackingErrorType.BACKEND_FIRST_PARTY */ .k9.BACKEND_FIRST_PARTY
      });
    }

    if (getServicesError && !firedEvents.servicesError) {
      setFiredEvents(_objectSpread(_objectSpread({}, firedEvents), {}, {
        servicesError: true
      }));
      trackEvent({
        dynamicTrackingData: dynamicTrackingData,
        eventPrimaryCategory: 'custom central form',
        eventEffect: 'call to services endpoint failed',
        eventCause: JSON.stringify(getBookingEngineError === null || getBookingEngineError === void 0 ? void 0 : getBookingEngineError.message),
        eventAction: shared_libraries_frontend_shared_src_models_Tracking__WEBPACK_IMPORTED_MODULE_4__/* .EventAction.LOAD_SERVICES_FAILED */ .AO.LOAD_SERVICES_FAILED,
        eventName: shared_libraries_frontend_shared_src_models_Tracking__WEBPACK_IMPORTED_MODULE_4__/* .EventName.ERROR */ .B_.ERROR,
        eventPoints: '200',
        eventType: shared_libraries_frontend_shared_src_models_Tracking__WEBPACK_IMPORTED_MODULE_4__/* .TrackingErrorType.BACKEND_FIRST_PARTY */ .k9.BACKEND_FIRST_PARTY
      });
    }
  }, [getDealerError, getBookingEngineError, getServicesError]);
  /* --------------- SRP Home page ------------------ */

  /* --------------- SRP Timeslot page ------------------ */

  var _ref3 = timeslotPage || {},
      isValidatingTimeslot = _ref3.isValidatingTimeslot,
      getTimeslotsError = _ref3.getTimeslotsError,
      timeslots = _ref3.timeslots,
      selectedDate = _ref3.selectedDate,
      receivedTimeslots = _ref3.receivedTimeslots,
      selectedTimeslot = _ref3.selectedTimeslot,
      isCalendarShown = _ref3.isCalendarShown;

  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null),
      formStep = _useState3[0],
      setFormStep = _useState3[1];

  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    var dynamicTrackingData = (0,_utils_tracking_utils__WEBPACK_IMPORTED_MODULE_10__/* .getDynamicTrackingData */ .Hp)({
      pageVariant: 'virtual page',
      pageSubCategory1: "step ".concat(3, "/8"),
      pageID: 'SRP date: date = form step 3',
      pageName: 'sales > oneshop > SRP date: date',
      locale: locale,
      brand: brand,
      dealer: dealer,
      customer: customer,
      vehicle: vehicle,
      services: selectedServices,
      stage: stage
    });

    if (!firedEvents.dateSelected && selectedDate) {
      setFiredEvents(_objectSpread(_objectSpread({}, firedEvents), {}, {
        dateSelected: true
      }));
      trackEvent({
        dynamicTrackingData: dynamicTrackingData,
        subCategory: 'oneshop service repair package form',
        subCategory2: 'handraiser',
        eventCause: 'default',
        eventEffect: 'sales > form step 3',
        eventAction: shared_libraries_frontend_shared_src_models_Tracking__WEBPACK_IMPORTED_MODULE_4__/* .EventAction.INTERNAL_CLICK */ .AO.INTERNAL_CLICK,
        eventName: shared_libraries_frontend_shared_src_models_Tracking__WEBPACK_IMPORTED_MODULE_4__/* .EventName.FORM */ .B_.FORM,
        eventPoints: '200',
        eventPrimaryCategory: 'custom central form',
        eventType: shared_libraries_frontend_shared_src_models_Tracking__WEBPACK_IMPORTED_MODULE_4__/* .TrackingEventType.RFS */ .Js.RFS
      });
    }
  }, [selectedDate]);
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    var dynamicTrackingData = (0,_utils_tracking_utils__WEBPACK_IMPORTED_MODULE_10__/* .getDynamicTrackingData */ .Hp)({
      pageVariant: 'virtual page',
      pageSubCategory1: "step ".concat(3, "/7"),
      pageID: 'SRP date: date = form step 3',
      pageName: 'sales > oneshop > SRP date: date',
      locale: locale,
      brand: brand,
      dealer: dealer,
      customer: customer,
      vehicle: vehicle,
      services: selectedServices,
      stage: stage
    });

    if (!isValidatingTimeslot && !getTimeslotsError && (0,_utils_timeslot_utils__WEBPACK_IMPORTED_MODULE_12__/* .isTimeslotsValid */ .R1)(timeslots) && isCalendarShown) {
      trackPageLoadEvent({
        trackingData: dynamicTrackingData
      });
      trackEvent({
        dynamicTrackingData: dynamicTrackingData,
        eventEffect: 'sales > form step 3',
        subCategory: 'oneshop service repair package form',
        subCategory2: 'handraiser',
        eventCause: 'default',
        eventAction: shared_libraries_frontend_shared_src_models_Tracking__WEBPACK_IMPORTED_MODULE_4__/* .EventAction.INTERNAL_CLICK */ .AO.INTERNAL_CLICK,
        eventName: shared_libraries_frontend_shared_src_models_Tracking__WEBPACK_IMPORTED_MODULE_4__/* .EventName.FORM */ .B_.FORM,
        eventPoints: '200',
        eventPrimaryCategory: 'custom central form',
        eventType: shared_libraries_frontend_shared_src_models_Tracking__WEBPACK_IMPORTED_MODULE_4__/* .TrackingEventType.RFS */ .Js.RFS
      });
    }

    if (getTimeslotsError && !firedEvents.timeslotLoadError) {
      setFiredEvents(_objectSpread(_objectSpread({}, firedEvents), {}, {
        timeslotLoadError: true
      }));
      trackEvent({
        dynamicTrackingData: dynamicTrackingData,
        eventPrimaryCategory: 'custom central form',
        eventEffect: 'call to timeslots endpoint failed',
        eventCause: JSON.stringify(getTimeslotsError === null || getTimeslotsError === void 0 ? void 0 : getTimeslotsError.message),
        eventAction: shared_libraries_frontend_shared_src_models_Tracking__WEBPACK_IMPORTED_MODULE_4__/* .EventAction.LOAD_TIMESLOTS_FAILED */ .AO.LOAD_TIMESLOTS_FAILED,
        eventName: shared_libraries_frontend_shared_src_models_Tracking__WEBPACK_IMPORTED_MODULE_4__/* .EventName.ERROR */ .B_.ERROR,
        eventPoints: '200',
        eventType: shared_libraries_frontend_shared_src_models_Tracking__WEBPACK_IMPORTED_MODULE_4__/* .TrackingErrorType.BACKEND_FIRST_PARTY */ .k9.BACKEND_FIRST_PARTY
      });
    }
  }, [isValidatingTimeslot, getTimeslotsError, timeslots, isCalendarShown]);
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    var availableTimeslots = (0,_utils_timeslot_utils__WEBPACK_IMPORTED_MODULE_12__/* .getAvailableTimeslots */ .bC)(receivedTimeslots, selectedDate);
    var dynamicTrackingData = (0,_utils_tracking_utils__WEBPACK_IMPORTED_MODULE_10__/* .getDynamicTrackingData */ .Hp)({
      pageVariant: 'virtual page',
      pageSubCategory1: "step ".concat(4, "/7"),
      pageID: 'SRP date: time = form step 4',
      pageName: 'sales > oneshop > SRP date: time',
      locale: locale,
      brand: brand,
      dealer: dealer,
      customer: customer,
      vehicle: vehicle,
      services: selectedServices,
      stage: stage
    });

    if (selectedDate && !isValidatingTimeslot && availableTimeslots && formStep !== 4) {
      setFormStep(4);
      trackPageLoadEvent({
        trackingData: dynamicTrackingData
      });
    }

    if (!availableTimeslots && selectedDate && !firedEvents.dateTimeError) {
      setFiredEvents(_objectSpread(_objectSpread({}, firedEvents), {}, {
        dateTimeError: true
      }));
      trackEvent({
        dynamicTrackingData: dynamicTrackingData,
        eventPrimaryCategory: 'custom central form',
        eventEffect: 'getting available timeslots for selected date failed',
        eventCause: JSON.stringify({
          receivedTimeslots: receivedTimeslots === null || receivedTimeslots === void 0 ? void 0 : receivedTimeslots.timeslotOptions,
          selectedDate: selectedDate
        }),
        eventAction: shared_libraries_frontend_shared_src_models_Tracking__WEBPACK_IMPORTED_MODULE_4__/* .EventAction.LOAD_TIMESLOT_FOR_DATE_FAILED */ .AO.LOAD_TIMESLOT_FOR_DATE_FAILED,
        eventName: shared_libraries_frontend_shared_src_models_Tracking__WEBPACK_IMPORTED_MODULE_4__/* .EventName.ERROR */ .B_.ERROR,
        eventPoints: '200',
        eventType: shared_libraries_frontend_shared_src_models_Tracking__WEBPACK_IMPORTED_MODULE_4__/* .TrackingErrorType.FRONTEND_COMPONENT */ .k9.FRONTEND_COMPONENT
      });
    }
  }, [receivedTimeslots === null || receivedTimeslots === void 0 ? void 0 : (_receivedTimeslots$ti = receivedTimeslots.timeslotOptions) === null || _receivedTimeslots$ti === void 0 ? void 0 : _receivedTimeslots$ti.length, isValidatingTimeslot, selectedDate]);
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    if (selectedTimeslot !== null && selectedTimeslot !== void 0 && selectedTimeslot.start) {
      if (!firedEvents.selectedTimeslot) {
        var dynamicTrackingData = (0,_utils_tracking_utils__WEBPACK_IMPORTED_MODULE_10__/* .getDynamicTrackingData */ .Hp)({
          pageVariant: 'virtual page',
          pageSubCategory1: "step ".concat(4, "/7"),
          pageID: 'SRP date: time = form step 4',
          pageName: 'sales > oneshop > SRP date: time',
          locale: locale,
          brand: brand,
          dealer: dealer,
          customer: customer,
          vehicle: vehicle,
          services: selectedServices,
          stage: stage
        });
        setFiredEvents(_objectSpread(_objectSpread({}, firedEvents), {}, {
          selectedTimeslot: true
        }));
        trackEvent({
          dynamicTrackingData: dynamicTrackingData,
          subCategory: 'oneshop service repair package form',
          subCategory2: 'handraiser',
          eventCause: 'default',
          eventEffect: 'sales > form step 4',
          eventAction: shared_libraries_frontend_shared_src_models_Tracking__WEBPACK_IMPORTED_MODULE_4__/* .EventAction.INTERNAL_CLICK */ .AO.INTERNAL_CLICK,
          eventName: shared_libraries_frontend_shared_src_models_Tracking__WEBPACK_IMPORTED_MODULE_4__/* .EventName.FORM */ .B_.FORM,
          eventPoints: '200',
          eventPrimaryCategory: 'custom central form',
          eventType: shared_libraries_frontend_shared_src_models_Tracking__WEBPACK_IMPORTED_MODULE_4__/* .TrackingEventType.RFS */ .Js.RFS
        });
      }
    }
  }, [selectedTimeslot]);
  /* --------------- SRP Timeslot page ------------------ */

  /* --------------- SRP Checkout page ------------------ */

  var _ref4 = checkoutPage || {},
      isSubmitAppointmentEnabled = _ref4.isSubmitAppointmentEnabled,
      currentEditSection = _ref4.currentEditSection,
      submitAppointmentError = _ref4.submitAppointmentError,
      isSubmittingAppointment = _ref4.isSubmittingAppointment,
      isAddressSaved = _ref4.isAddressSaved,
      isPersonalDataSaved = _ref4.isPersonalDataSaved,
      hasAcceptedDataRelay = _ref4.hasAcceptedDataRelay;

  var getCheckoutStepPageInfo = function getCheckoutStepPageInfo(currentEditSection) {
    switch (currentEditSection) {
      case shared_model__WEBPACK_IMPORTED_MODULE_6__.CheckoutSection.PERSONAL_DATA:
        return {
          pageSubCategory1: "step ".concat(5, "/7"),
          pageID: 'SRP checkout: personal detail = form step 5',
          pageName: 'sales > oneshop > SRP checkout: personal detail'
        };

      case shared_model__WEBPACK_IMPORTED_MODULE_6__.CheckoutSection.ADDRESS_DATA:
        return {
          pageSubCategory1: "step ".concat(6, "/7"),
          pageID: 'SRP checkout: address detail = form step 6',
          pageName: 'sales > oneshop > SRP checkout: address detail'
        };

      default:
        return {
          pageSubCategory1: "step ".concat(7, "/7"),
          pageID: 'SRP checkout: summary = form step 7',
          pageName: 'sales > oneshop > SRP checkout: summary'
        };
    }
  };

  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    if (isSubmitAppointmentEnabled && isEpaasLoaded) {
      var dynamicTrackingData = (0,_utils_tracking_utils__WEBPACK_IMPORTED_MODULE_10__/* .getDynamicTrackingData */ .Hp)(_objectSpread(_objectSpread({
        pageVariant: 'virtual page'
      }, getCheckoutStepPageInfo(currentEditSection)), {}, {
        locale: locale,
        brand: brand,
        dealer: dealer,
        customer: customer,
        vehicle: vehicle,
        services: selectedServices,
        stage: stage
      }));
      trackPageLoadEvent({
        trackingData: dynamicTrackingData
      });
    }
  }, [isSubmitAppointmentEnabled, currentEditSection, isEpaasLoaded]);
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    if (isPersonalDataSaved && !firedEvents.isPersonalDataSaved) {
      setFiredEvents(_objectSpread(_objectSpread({}, firedEvents), {}, {
        isPersonalDataSaved: true
      }));
      trackEvent({
        dynamicTrackingData: (0,_utils_tracking_utils__WEBPACK_IMPORTED_MODULE_10__/* .getDynamicTrackingData */ .Hp)(_objectSpread(_objectSpread({
          pageVariant: 'virtual page'
        }, getCheckoutStepPageInfo(shared_model__WEBPACK_IMPORTED_MODULE_6__.CheckoutSection.PERSONAL_DATA)), {}, {
          locale: locale,
          brand: brand,
          dealer: dealer,
          customer: customer,
          vehicle: vehicle,
          services: selectedServices,
          stage: stage
        })),
        subCategory: 'oneshop service repair package form',
        subCategory2: 'handraiser',
        eventCause: 'default',
        eventEffect: 'sales > form step 5',
        eventAction: shared_libraries_frontend_shared_src_models_Tracking__WEBPACK_IMPORTED_MODULE_4__/* .EventAction.INTERNAL_CLICK */ .AO.INTERNAL_CLICK,
        eventName: shared_libraries_frontend_shared_src_models_Tracking__WEBPACK_IMPORTED_MODULE_4__/* .EventName.FORM */ .B_.FORM,
        eventPoints: '200',
        eventPrimaryCategory: 'custom central form',
        eventType: shared_libraries_frontend_shared_src_models_Tracking__WEBPACK_IMPORTED_MODULE_4__/* .TrackingEventType.RFS */ .Js.RFS
      });
    }

    if (isAddressSaved && !firedEvents.isAddressSaved) {
      setFiredEvents(_objectSpread(_objectSpread({}, firedEvents), {}, {
        isAddressSaved: true
      }));
      trackEvent({
        dynamicTrackingData: (0,_utils_tracking_utils__WEBPACK_IMPORTED_MODULE_10__/* .getDynamicTrackingData */ .Hp)(_objectSpread(_objectSpread({
          pageVariant: 'virtual page'
        }, getCheckoutStepPageInfo(shared_model__WEBPACK_IMPORTED_MODULE_6__.CheckoutSection.ADDRESS_DATA)), {}, {
          locale: locale,
          brand: brand,
          dealer: dealer,
          customer: customer,
          vehicle: vehicle,
          services: selectedServices,
          stage: stage
        })),
        subCategory: 'oneshop service repair package form',
        subCategory2: 'handraiser',
        eventCause: 'default',
        eventEffect: 'sales > form step 6',
        eventAction: shared_libraries_frontend_shared_src_models_Tracking__WEBPACK_IMPORTED_MODULE_4__/* .EventAction.INTERNAL_CLICK */ .AO.INTERNAL_CLICK,
        eventName: shared_libraries_frontend_shared_src_models_Tracking__WEBPACK_IMPORTED_MODULE_4__/* .EventName.FORM */ .B_.FORM,
        eventPoints: '200',
        eventPrimaryCategory: 'custom central form',
        eventType: shared_libraries_frontend_shared_src_models_Tracking__WEBPACK_IMPORTED_MODULE_4__/* .TrackingEventType.RFS */ .Js.RFS
      });
    }

    if (hasAcceptedDataRelay && !firedEvents.hasAcceptedDataRelay) {
      setFiredEvents(_objectSpread(_objectSpread({}, firedEvents), {}, {
        hasAcceptedDataRelay: true
      }));
      trackEvent({
        dynamicTrackingData: (0,_utils_tracking_utils__WEBPACK_IMPORTED_MODULE_10__/* .getDynamicTrackingData */ .Hp)(_objectSpread(_objectSpread({
          pageVariant: 'virtual page'
        }, getCheckoutStepPageInfo(currentEditSection)), {}, {
          locale: locale,
          brand: brand,
          dealer: dealer,
          customer: customer,
          vehicle: vehicle,
          services: selectedServices,
          stage: stage
        })),
        subCategory: 'oneshop service repair package form',
        subCategory2: 'handraiser',
        eventCause: 'default',
        eventEffect: 'sales > form step 7',
        eventAction: shared_libraries_frontend_shared_src_models_Tracking__WEBPACK_IMPORTED_MODULE_4__/* .EventAction.INTERNAL_CLICK */ .AO.INTERNAL_CLICK,
        eventName: shared_libraries_frontend_shared_src_models_Tracking__WEBPACK_IMPORTED_MODULE_4__/* .EventName.FORM */ .B_.FORM,
        eventPoints: '200',
        eventPrimaryCategory: 'custom central form',
        eventType: shared_libraries_frontend_shared_src_models_Tracking__WEBPACK_IMPORTED_MODULE_4__/* .TrackingEventType.RFS */ .Js.RFS
      });
    }
  }, [isAddressSaved, isPersonalDataSaved, hasAcceptedDataRelay]);
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    var dynamicTrackingData = (0,_utils_tracking_utils__WEBPACK_IMPORTED_MODULE_10__/* .getDynamicTrackingData */ .Hp)({
      pageVariant: 'virtual page',
      pageSubCategory1: "step ".concat(7, "/7"),
      pageID: 'SRP checkout: = form finished intention',
      pageName: 'sales > oneshop > SRP checkout: form finished intention',
      locale: locale,
      brand: brand,
      dealer: dealer,
      customer: customer,
      vehicle: vehicle,
      services: selectedServices,
      stage: stage
    });

    if (submitAppointmentError && !firedEvents.submitAppointmentError) {
      setFiredEvents(_objectSpread(_objectSpread({}, firedEvents), {}, {
        submitAppointmentError: true
      }));
      trackEvent({
        dynamicTrackingData: dynamicTrackingData,
        eventPrimaryCategory: 'custom central form',
        eventEffect: 'submitting customer appointment has failed',
        eventCause: JSON.stringify(getTimeslotsError === null || getTimeslotsError === void 0 ? void 0 : getTimeslotsError.message),
        eventAction: shared_libraries_frontend_shared_src_models_Tracking__WEBPACK_IMPORTED_MODULE_4__/* .EventAction.SUBMIT_APPOINTMENT_FAILED */ .AO.SUBMIT_APPOINTMENT_FAILED,
        eventName: shared_libraries_frontend_shared_src_models_Tracking__WEBPACK_IMPORTED_MODULE_4__/* .EventName.ERROR */ .B_.ERROR,
        eventPoints: '200',
        eventType: shared_libraries_frontend_shared_src_models_Tracking__WEBPACK_IMPORTED_MODULE_4__/* .TrackingErrorType.BACKEND_FIRST_PARTY */ .k9.BACKEND_FIRST_PARTY
      });
    }

    if (isSubmittingAppointment && !firedEvents.isSubmittingAppointment) {
      setFiredEvents(_objectSpread(_objectSpread({}, firedEvents), {}, {
        isSubmittingAppointment: true
      }));
      trackEvent({
        dynamicTrackingData: dynamicTrackingData,
        subCategory: 'oneshop service repair package form',
        subCategory2: 'handraiser',
        eventCause: 'default',
        eventEffect: 'sales > form finished intention',
        eventAction: shared_libraries_frontend_shared_src_models_Tracking__WEBPACK_IMPORTED_MODULE_4__/* .EventAction.INTERNAL_CLICK */ .AO.INTERNAL_CLICK,
        eventName: shared_libraries_frontend_shared_src_models_Tracking__WEBPACK_IMPORTED_MODULE_4__/* .EventName.FORM */ .B_.FORM,
        eventPoints: '200',
        eventPrimaryCategory: 'custom central form',
        eventType: shared_libraries_frontend_shared_src_models_Tracking__WEBPACK_IMPORTED_MODULE_4__/* .TrackingEventType.RFS */ .Js.RFS
      });
    }
  }, [submitAppointmentError, isSubmittingAppointment]);
  /* --------------- SRP Checkout page ------------------ */

  /* --------------- SRP Confirmation page ------------------ */

  var _ref5 = confirmationPage || {},
      appointmentData = _ref5.appointmentData,
      userConsents = _ref5.userConsents;

  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    var isConsentRender = false;
    isConsentRender = userConsents ? shared_libraries_frontend_shared_src_utils_checkout_utils__WEBPACK_IMPORTED_MODULE_5__/* ["default"].isConsentRendered */ .Z.isConsentRendered(userConsents, optinVersion) : undefined;
    var dynamicTrackingData = (0,_utils_tracking_utils__WEBPACK_IMPORTED_MODULE_10__/* .getDynamicTrackingData */ .Hp)({
      pageVariant: 'real page',
      pageSubCategory1: "",
      pageSubCategory2: 'dedicated form',
      pageSubCategory3: !isConsentRender ? 'no consent shown' : optinVersion === 'A' ? 'consent version A shown' : 'consent version B shown',
      pageID: 'sales > oneshop > form > SRP checkout: success',
      pageName: 'sales > oneshop > SRP checkout: success',
      locale: locale,
      brand: brand,
      dealer: dealer,
      customer: customer,
      vehicle: vehicle,
      services: selectedServices,
      stage: stage
    });

    if (appointmentData) {
      trackPageLoadEvent({
        trackingData: dynamicTrackingData
      });
    }

    if (appointmentData && isEpaasLoaded && !firedEvents.confirmation) {
      setFiredEvents(_objectSpread(_objectSpread({}, firedEvents), {}, {
        confirmation: true
      }));
      trackEvent({
        dynamicTrackingData: dynamicTrackingData,
        subCategory: 'oneshop service repair package form',
        subCategory2: 'handraiser',
        eventCause: 'default',
        eventEffect: 'sales > form finished',
        eventAction: shared_libraries_frontend_shared_src_models_Tracking__WEBPACK_IMPORTED_MODULE_4__/* .EventAction.PAGE_LOAD */ .AO.PAGE_LOAD,
        eventName: shared_libraries_frontend_shared_src_models_Tracking__WEBPACK_IMPORTED_MODULE_4__/* .EventName.FORM */ .B_.FORM,
        eventPoints: '200',
        eventPrimaryCategory: 'custom central form',
        eventType: shared_libraries_frontend_shared_src_models_Tracking__WEBPACK_IMPORTED_MODULE_4__/* .TrackingEventType.RFS */ .Js.RFS
      });
    }
  }, [appointmentData]);
  /* --------------- SRP Confirmation page ------------------ */

  return null;
};

/***/ }),

/***/ 3998:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Pn": function() { return /* binding */ getMobilityOptionTitle; },
/* harmony export */   "ig": function() { return /* binding */ reducePreloadResponse; },
/* harmony export */   "oN": function() { return /* binding */ findDueServices; },
/* harmony export */   "v8": function() { return /* binding */ mapPreloadResponseToGuestServiceResponse; }
/* harmony export */ });
/* unused harmony export sortByDueServices */
/* harmony import */ var _var_jenkins_home_workspace_wepf_mybmwweb_appointments_main_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _var_jenkins_home_workspace_wepf_mybmwweb_appointments_main_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27812);



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_var_jenkins_home_workspace_wepf_mybmwweb_appointments_main_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var getMobilityOptionTitle = function getMobilityOptionTitle(mobilityOptions, mobilityOptionId) {
  var _mobilityOptions$find;

  return (_mobilityOptions$find = mobilityOptions.find(function (mobOption) {
    return mobOption.id === mobilityOptionId;
  })) === null || _mobilityOptions$find === void 0 ? void 0 : _mobilityOptions$find.title;
};

var reducePreloadResponse = function reducePreloadResponse(preload, key) {
  return preload.reduce(function (prev, curr) {
    return [].concat((0,_var_jenkins_home_workspace_wepf_mybmwweb_appointments_main_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(prev), [curr[key]]);
  }, []).join(',');
};

function mapPreloadResponseToGuestServiceResponse(preload) {
  return _objectSpread(_objectSpread({}, preload), {}, {
    services: sortByDueServices(preload.services.services),
    mobilityOptions: preload.services.mobilityOptions
  });
}

var sortByDueServices = function sortByDueServices(services) {
  var _services$sort;

  return (_services$sort = services === null || services === void 0 ? void 0 : services.sort(function (service) {
    return service.isServiceDue ? -1 : 1;
  })) !== null && _services$sort !== void 0 ? _services$sort : [];
};

var findDueServices = function findDueServices(services) {
  var _services$filter;

  return (_services$filter = services === null || services === void 0 ? void 0 : services.filter(function (service) {
    return service.isServiceDue;
  })) !== null && _services$filter !== void 0 ? _services$filter : [];
};



/***/ })

}]);